<template>
  <v-layout column class="summary-table">
    <v-layout class="summary-table-header">
      <v-flex xs1 align-center justify-center> </v-flex>
      <v-flex class="label" xs7> {{ headers[0] }} </v-flex>
      <v-flex class="count" xs2>
        {{ headers[1] }}
      </v-flex>
      <v-flex class="percent" xs2>
        {{ headers[2] }}
      </v-flex>
    </v-layout>
    <v-layout column class="summary-table-body">
      <v-flex
        v-for="(label, i) in rows"
        :key="label.label"
        class="summary-table-row"
      >
        <v-layout fill-height>
          <v-flex xs1 align-center justify-center d-flex
            ><div
              style="max-width: 15px; height: 15px; "
              :style="{
                'background-color': label.color
              }"
            ></div
          ></v-flex>
          <v-flex class="label" xs7>
            {{ label.label }}
          </v-flex>
          <v-flex class="count" xs2>
            {{ label.count }}
          </v-flex>
          <v-flex class="percent" xs2> {{ label.percent }}% </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'SummaryTable',
  props: {
    headers: Array,
    rows: Array
  }
}
</script>

<style lang="stylus">
    .summary-table {
        max-width 600px
    }
.summary-table-header {
    background: $color-primary-light-7;
    border: 1px solid $color-primary-light-8;
    box-sizing: border-box;
    border-radius: 5px 5px 0px 0px;
    height 46px
    padding 0 10px
    .label, .count, .percent {
        display flex
        align-items center
        justify-content center
        color: $color-primary-light-1
        font-size 14px
        font-weight 500
    }
    .label {
        justify-content left
    }
}
.summary-table-body {
    background: #FFFFFF;
    border: 1px solid $color-primary-light-8;
    box-sizing: border-box;
    border-radius: 0px 0px 5px 5px;
    padding 15px 10px
}
.summary-table-row {
    height 40px
    .label, .count, .percent {
        display flex
        align-items center
        color $color-primary-light-4
        font-size 16px
    }
    .count, .percent {
        justify-content center
    }

}
</style>
